import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 0 auto 15px auto;
  width: 150px;
`;

export default Wrapper;